import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "../components/login/login";
import ScreenPagePart from "../components/login/screenpage";

const SigninPage = () => {
  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        <LoginForm isSignup={false} />
      </div>
    </ScreenPagePart>
  );
};

export default SigninPage;
